// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Directories_projectsContainer__ikY7q"};